module.exports = __webpack_public_path__ + "static/media/mati.aa0d063a.jpg";